import { ColDef } from "ag-grid-community";
import { IForm } from "../../../laco-common";

export * from "./boolean";
export * from "./date";
export * from "./numeric";

export type IFormsGridContext = {
	formConfigMap: { [formId: string]: IForm };
};

export const ID_COL_DEF: ColDef = {
	field: "id",
	colId: "id",
	headerName: "Id",
	headerTooltip: "Id",
};
